import { render, staticRenderFns } from "./AdminEditGenericVehicle.vue?vue&type=template&id=23aa9dc2&scoped=true&"
import script from "./AdminEditGenericVehicle.vue?vue&type=script&lang=js&"
export * from "./AdminEditGenericVehicle.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditGenericVehicle.vue?vue&type=style&index=0&id=23aa9dc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aa9dc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23aa9dc2')) {
      api.createRecord('23aa9dc2', component.options)
    } else {
      api.reload('23aa9dc2', component.options)
    }
    module.hot.accept("./AdminEditGenericVehicle.vue?vue&type=template&id=23aa9dc2&scoped=true&", function () {
      api.rerender('23aa9dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/device_types/AdminEditGenericVehicle.vue"
export default component.exports